export const SETTINGS_ROUTE_NAMES = {
    INDEX: "SettingsIndex",
    CATEGORY_EDITOR: "SettingsCategoryEditor",
    CONTRACTS_LIST: "SettingsContractsList",
    CONTRACTS_ADD: "SettingsContractsAdd",
    CONTRACTS_EDIT: "SettingsContractsEdit",
    INTEGRATIONS: "SettingsIntegrations",
};
